export const initCatalogPage = function() {
  const catalogPageParentItem = document.querySelectorAll('[data-element-parent-more]');

  if (catalogPageParentItem.length > 0) {
    catalogPageParentItem.forEach((item) => {
      const heightList = item.querySelector('.catalog-page__sublist').offsetHeight;
      const link = item.querySelector('.catalog-page__more');
      const list = item.querySelector('.catalog-page__sublist');
      if (heightList < 140) {
        if (link) {
          link.classList.add('is-hidden');
        }
      }
      // if (list) {
      //   const item = list.querySelectorAll('li');
      //   if (item.length > 0) {
      //     const itemNum = link.querySelector('.catalog-page__more-num');
      //     const itemCounter = item.length - 5;
      //     if (itemNum) {
      //       itemNum.textContent = `(${itemCounter})`;
      //     }
      //   }
      // }

    })
  }
}
